exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-6b45c297]{font-size:16px}input[data-v-6b45c297]{border:0;border-bottom:1px solid;padding-left:6px}.border-bottom[data-v-6b45c297]{display:inline-block;border-bottom:1px solid;padding-left:5px;max-height:28px;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6b45c297","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/addOrEditWgs.vue
// module id = ZD9U
// module chunks = 0